//
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Enum } from 'enumify'

import { AuthContext } from '../contexts/AuthContext'

export const withAuth = (ComponentToWrap) => {
  const WrappedComponent = (props) => {
    return (
      <AuthContext.Consumer>
        {authContext => (
          <ComponentToWrap {...props} authContext={authContext} />
        )}
      </AuthContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withAuth(${ComponentToWrap.displayName || ComponentToWrap.name})`
  return WrappedComponent
}

const AuthProviderComponent = (props) => {
  const { children } = props
  const [authToken, setAuthToken] = useState(null)

  return (
    <AuthContext.Provider value={{ authToken, setAuthToken }}>
      {children}
    </AuthContext.Provider>
  )
}

AuthProviderComponent.defaultProps = {
  children: null
}

AuthProviderComponent.propTypes = {
  children: PropTypes.node
}

export const AuthProvider = AuthProviderComponent

export class LoginTypeEnum extends Enum {}
LoginTypeEnum.initEnum(['WebLogin', 'AdmLogin', 'AdmLoginLimited', 'ResellerLogin'])
